/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_2110a62a"]'><cube-button primary active>激活态</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_2110a62a"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_2110a62a"}
  /** script content **/
  require("./btn-primary-active.mpx.js?isComponent&outputPath=components%2Fbtn-primary-active2110a62a%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-primary-active.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-primary-active2110a62a%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_2110a62a"],
    ctorType: "component",
    outputPath: "components/btn-primary-active2110a62a/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>